export default "__VITE_ASSET__CbAWpvZn__"